import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ContactUsSection = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: 'async-contact-us' */ './contact-us-section')),
});
